import "../agradecimento/agradecimento.css";
import sbfLogo from "../../assets/SBF-Logo-1.png";

const TokenInvalido = () => {
  return (
    <div className="container-agradecimento">
      <div className="barra-header"></div>
      <img src={sbfLogo} alt="SBF" className="logo-agradecimento" />
      <div
        style={{
          width: "60%",
          marginTop: "25px",
          fontSize: "19px",
          textAlign: "center",
        }}
      >
        <p>
          <b>Token Expirado ou Inválido</b>
          <br />
          <br />
          O link de acesso que você está tentando utilizar expirou ou não é mais válido.
          <br />
          <br />
          Entre em contato com o suporte pelo e-mail:{" "}
          <b>sbf@informa.com</b>
          <br />
          <br />
          <b>Nosso time está pronto para te ajudar!</b>
        </p>
      </div>
    </div>
  );
};

export default TokenInvalido; 